import { onMount } from "solid-js";

export default function ExoclickScript() {
  onMount(() => {
    const exoclickScript = document.createElement("script");
    exoclickScript.type = "application/javascript";
    exoclickScript.src = "https://a.exoclick.com/tag_gen.js";
    exoclickScript.setAttribute(
      "data-goal",
      "a6074710358abe90ea81e3e5576f0087",
    );
    document.body.appendChild(exoclickScript);
  });

  return null;
}
